import { bytesToMegabytes } from './bytes-to-megabytes';

export function acceptableFileSize(
  fileByteSize: number,
  maxMBSize: number
): boolean {
  return bytesToMegabytes(fileByteSize) < maxMBSize;
}
